import {
  URL_CARRIER_USERMANAGEMENT_API,
  URL_UI_DEV,
  URL_UI_PROD,
} from "api/constants";

const isProd = window.location.hostname.includes("prod");

export const appConfig = isProd
  ? {
      apiUrl: URL_CARRIER_USERMANAGEMENT_API,
      uiUrl: URL_UI_PROD,
    }
  : {
      apiUrl: URL_CARRIER_USERMANAGEMENT_API,
      uiUrl: URL_UI_DEV,
    };

export default appConfig;
